import React from 'react';
import PoiCard from 'components/cards/poi/PoiCard';
import { PuscicaDesno } from 'kzv-icons';
import Button from 'components/buttons/Button';
import Destination from 'models/Destination';
import Category from 'models/Category';

function DestinationCategory({ category, destination }: { category: Category; destination: Destination }) {
    return (
        <div className="container px-0 md:px-6">
            <h1 className="text-2xl text-center md:text-4xl mb-12 px-4">
                {category.name} v destinaciji {destination.name}
            </h1>

            <div
                className={`flex flex-row max-w-full gap-8 overflow-auto sm:overflow-visible sm:grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 3xl:grid-cols-5 xl:gap-10 3xl:gap-14 pb-4 px-4 md:px-0`}
            >
                {category.pois.slice(0, 8).map((poi) => {
                    return (
                        <div className="min-w-[280px]" key={poi.id}>
                            <PoiCard
                                link={`/ideja/${poi.slug}`}
                                title={poi.name}
                                location={poi.name}
                                images={poi.thumbs}
                                attributes={poi.attributes}
                                category={category}
                                poiType={poi.type}
                            />
                        </div>
                    );
                })}
            </div>
            <div className="text-center mt-6">
                <Button
                    endIcon={<PuscicaDesno />}
                    link={`/ideje/${destination.slug}/${category.slug}`}
                    color="secondary"
                >
                    Poglej vse
                </Button>
            </div>
        </div>
    );
}

export default DestinationCategory;
